import { LegacyRef, forwardRef } from 'react';
import { ScrollView } from 'react-native';

import Cover from './Cover';
import { Props } from './ScrollWithCover';

/**
 * According to the bugs of rnw ScrollView,
 * cover animation should not be apply yet.
 *
 * Bugs:
 * - Scroll to a negative value, will encounter a bouncing glitch.
 * - Animated.event on web is not smooth.
 *
 * TODO: Remove this file if ScrollView is fixed on rnWeb,
 *       or refactor with another technic.
 */
const ScrollWithCover = forwardRef(
  (props: Props, ref: LegacyRef<ScrollView>) => {
    const {
      coverSource,
      coverHeight,
      bgColor,
      showPlaceholder,
      children,
      onCoverLoadEnd,
      ...others
    } = props;

    return (
      <ScrollView {...others} ref={ref}>
        <Cover
          coverSource={coverSource}
          coverHeight={coverHeight}
          bgColor={bgColor}
          showPlaceholder={showPlaceholder}
          onLoadEnd={onCoverLoadEnd}
        />
        {children}
      </ScrollView>
    );
  }
);

export default ScrollWithCover;
